import { del, get, post, put } from "../api";

export const getBiensRecents = async () => {
    try {
        const response = await get("/v1/biens/recents");
        const data = await response.data?.data;
        return data;
    } catch (error) {
        console.error("Error fetching biens:", error);
        return [];
    }
};
export const getBiens = async () => {
    try {
        const response = await get("/v1/biens");
        const data = await response.data?.data;
        return data;
    } catch (error) {
        console.error("Error fetching biens:", error);
        return [];
    }
};

export const ajouterBien = async (bien:any) => {
    try {
        const response = await post("/v1/biens", bien); 
        const data = await response.data?.data;
        return data;
    } catch (error) {
        console.error("Error adding bien:", error);
        throw error;
    }       
}



export const getBienById = async (id: number) => {
    try {
        const response = await get(`/v1/biens/${id}`);      
        const data = await response.data?.data;
        return data;
    }   catch (error) { 
        console.error(`Error fetching bien with id ${id}:`, error);
        return null;
    }   
};


export const modifierBien = async (bien:any) => {
    try {
        const response = await put("/v1/biens", bien); 
        const data = await response.data?.data;
        return data;
    } catch (error) {
        console.error("Error adding bien:", error);
        throw error;
    }       
}



export const supprimerBien = async (bienId:number) => {
    try {
        const response = await del(`/v1/biens/${bienId}`); 
        const data = await response.data?.data;
        return data;
    } catch (error) {
        console.error("Error adding bien:", error);
        throw error;
    }       
}
